var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "textarea-button"
  }, [_c('textarea', {
    ref: "textareaRef",
    staticClass: "textarea-button__field",
    class: [{
      'textarea-button__field_error': _vm.error
    }],
    style: {
      height: ((_vm.height) + "px"),
      minHeight: ((_vm.height) + "px"),
      padding: _vm.padding,
      border: _vm.border,
      borderRadius: _vm.borderRadius
    },
    attrs: {
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": _vm.modelValue
    },
    on: {
      "input": _vm.onInput
    }
  }), _vm._v(" "), _vm.isShowIcon ? _c('div', {
    staticClass: "textarea-button__icon",
    attrs: {
      "title": "Ответить"
    },
    on: {
      "click": function ($event) {
        return _vm.emit('click');
      }
    }
  }) : _vm._e()]);
}
var staticRenderFns = []

export { render, staticRenderFns }